import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('i18nextLng') || 'ar',
    fallbackLng: 'ar',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

// Set initial direction based on language
const normalizeLanguage = (lng: string) => lng.split("-")[0];

const setDirection = (lng: string) => {
  const normalized = normalizeLanguage(lng);
  document.documentElement.dir = normalized === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = normalized;
};

setDirection(i18n.language || localStorage.getItem('i18nextLng') || 'ar');

i18n.on('languageChanged', (lng) => {
  const normalized = normalizeLanguage(lng);
  localStorage.setItem('i18nextLng', normalized);
  setDirection(lng);
});

export default i18n;